'use client'

import { useEffect } from 'react'

/**
 * DisableTrackingForWhitelabel
 *
 * Client component que detecta hostname (paty/funil/etc) e DESLIGA
 * scripts de tracking eBuz no client-side. Roda no useLayoutEffect-like
 * timing, antes do GTM/FB/GA carregarem.
 *
 * Estratégia: define `window['ga-disable-{ID}'] = true` e neutraliza
 * `window.dataLayer`, `window.fbq`, `window.mt` antes deles carregarem.
 *
 * Não previne o script tag de aparecer no HTML, mas previne o tracking
 * de disparar eventos / enviar pra eBuz.
 *
 * Long-term fix: SSR detection no RootLayout (não está funcionando por
 * algum cache do Next.js 15). Esse client-side é workaround robusto.
 */
export function DisableTrackingForWhitelabel() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    const host = window.location.hostname.toLowerCase()
    const isWhitelabel = host.endsWith('patyshiatsu.com.br') ||
                          host.endsWith('funilchatbot.com.br') ||
                          host.endsWith('antoniofogaca.com.br')
    if (!isWhitelabel) return

    // Desliga GTM/GA4 ebuz
    const w = window as unknown as Record<string, unknown>
    w['ga-disable-G-MQSN80ECBR'] = true
    w['ga-disable-GTM-NQV9CG5V'] = true

    // Bloqueia dataLayer push pra GTM ebuz
    if (Array.isArray(w.dataLayer)) {
      // dataLayer já existe — sobrescreve push pra noop
      (w.dataLayer as { push?: (..._args: unknown[]) => void }).push = () => { /* noop */ }
    } else {
      // Cria stub que captura mas não envia
      w.dataLayer = []
      ;(w.dataLayer as { push?: (..._args: unknown[]) => void }).push = () => { /* noop */ }
    }

    // Bloqueia FB Pixel
    w.fbq = (() => { /* noop */ }) as unknown
    w._fbq = w.fbq

    // Bloqueia Mautic
    w.mt = (() => { /* noop */ }) as unknown
    w.MauticTrackingObject = 'mt'
  }, [])

  return null
}
